module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      display: 'inline-block',
      'margin-right': _vm.getSpacing
    })
  }, [_c('svg', {
    staticStyle: {
      "overflow": "visible"
    },
    attrs: {
      "width": _vm.getWidth,
      "height": _vm.getHeight,
      "viewBox": _vm.getViewbox
    },
    on: {
      "mousemove": _vm.mouseMoving,
      "click": _vm.selected
    }
  }, [_c('linearGradient', _vm._b({
    attrs: {
      "id": _vm.fillId
    }
  }, 'linearGradient', _vm.coords, false), [_c('stop', {
    attrs: {
      "offset": _vm.getFill,
      "stop-color": (_vm.rtl) ? _vm.inactiveColor : _vm.activeColor
    }
  }), _vm._v(" "), _c('stop', {
    attrs: {
      "offset": _vm.getFill,
      "stop-color": (_vm.rtl) ? _vm.activeColor : _vm.inactiveColor
    }
  })], 1), _vm._v(" "), _c('path', _vm._b({
    attrs: {
      "d": _vm.pointsToString,
      "fill": _vm.getFillId,
      "stroke": _vm.borderColor,
      "stroke-width": _vm.borderWidth,
      "vector-effect": "non-scaling-stroke"
    }
  }, 'path', _vm.pathAttrs, false)), _vm._v(" "), _c('path', _vm._b({
    attrs: {
      "d": _vm.pointsToString,
      "fill": _vm.getFillId
    }
  }, 'path', _vm.pathAttrs, false))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-7ee0425c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/templates/Path.vue
// module id = 14
// module chunks = 0 1 2 3 4 5